module.exports = __webpack_public_path__ + "img/image-02.e8d4441b.webp";